export enum PermissionAction {
  View = 'view', // view only, no further actions possible
  ViewAlways = 'ViewAlways', // this permission is associated to Meply roles (Reviewer, Hr_Readonly, Hr_Admin, GlobalAdmin). It has the highest priority among all permissions
  Update = 'update', // view and edit -> discuss whether "update" also means to delete sth
  Create = 'create', // view, edit and create new
  Delete = 'delete', // view, edit, create new, delete
  Execute = 'execute', // execute further actions / requests, no correlation to other actions
  Hide = 'hide', // needed to hide functionalities
}
